export default "__VITE_ASSET__ef3a911c__"